import type { ThemeTokens } from '../types';
import { tealLight } from './tealLight';

/**
 * Teal Dark — mirrors the [data-theme='dark'] block in variables.css.
 * Spreads tealLight and overrides only the values that change in dark mode.
 */
export const tealDark: ThemeTokens = {
  ...tealLight,
  id: 'teal-dark',
  name: 'Teal Dark',
  colorMode: 'dark',

  // Surface
  bgColor:     '#0b1120',
  bgSubtle:    '#111827',
  cardBgColor: '#161f2e',
  hoverColor:  '#1a2d3a',
  activeColor: '#1e3a3a',

  // Brand (dark versions)
  primarySubtle:  'rgba(58, 141, 141, 0.12)',
  gradientSubtle: 'linear-gradient(135deg, rgba(58,141,141,0.12) 0%, rgba(37,99,235,0.12) 100%)',

  // Text
  textDark:   '#f0f6ff',
  textMedium: '#94a3b8',
  textLight:  '#4b6280',

  // Border
  borderColor: '#1e293b',
  borderLight: '#162032',

  // Shadows (darker)
  shadowXs: '0 1px 2px rgba(0, 0, 0, 0.3)',
  shadowSm: '0 1px 3px rgba(0, 0, 0, 0.4), 0 1px 2px rgba(0, 0, 0, 0.3)',
  shadowMd: '0 4px 12px rgba(0, 0, 0, 0.4), 0 2px 4px rgba(0, 0, 0, 0.3)',
  shadowLg: '0 12px 28px rgba(0, 0, 0, 0.5), 0 4px 8px rgba(0, 0, 0, 0.35)',
  shadowXl: '0 24px 48px rgba(0, 0, 0, 0.6), 0 8px 16px rgba(0, 0, 0, 0.4)',

  // Status (dark)
  successBg:     'rgba(16, 185, 129, 0.10)',
  successBorder: 'rgba(21, 128, 61, 0.30)',
  successText:   '#4ade80',
  warningBg:     'rgba(146, 64, 14, 0.15)',
  warningBorder: 'rgba(252, 211, 77, 0.30)',
  warningText:   '#fcd34d',
  dangerBg:      'rgba(220, 38, 38, 0.10)',
  dangerBorder:  'rgba(220, 38, 38, 0.30)',
  dangerText:    '#f87171',
  infoBg:        'rgba(59, 130, 246, 0.15)',
  infoBorder:    'rgba(59, 130, 246, 0.30)',
  infoText:      '#93c5fd',

  // Interaction (dark)
  dangerHoverBg: 'rgba(220, 38, 38, 0.12)',
  backdropColor: 'rgba(11, 17, 32, 0.65)',
};
